import React, {useState, useEffect} from 'react';
import { makeStyles, DialogContent, Dialog, Button, TextField} from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CloseIcon from '@material-ui/icons/Close';


export default function SecretDialog(props) {
    const classes = useStyles();
    const [secrets, setSecrets] = useState([]);

    useEffect(() => {
        console.log(props.secrets)
        console.log(secrets)
        if(props.secrets !== undefined && (secrets === undefined || JSON.stringify(secrets) === JSON.stringify([])) ){
            if (JSON.stringify(props.secrets) !== JSON.stringify(secrets) ){
                setSecrets(props.secrets);
                console.log(secrets)
            }  
        }else{
            if(secrets === undefined){
                setSecrets([]);
                console.log(secrets)
            }
        }
    }, [props.secrets, secrets]);

    const mapSecrets = () => {
        if(secrets) {
            console.log("grid");
            return secrets.map((prop, index) => (
                GetLineForSecret(prop, index)                        
            ))
        }
    }

    const fieldChanged = (index, value, column) => {
        let obj = [...secrets];
        obj[index][column] = value
        setSecrets(obj);
        console.log(secrets)
    }
    
    const GetLineForSecret = (secret, index) => {
        return <TableRow>
                    <TableCell><TextField type="text" onChange={(e) => fieldChanged(index, e.target.value, "description")} defaultValue={secret.description} /></TableCell>
                    <TableCell><TextField type="text" onChange={(e) => fieldChanged(index, e.target.value, "value")} defaultValue={secret.value} /></TableCell>
                    <TableCell><TextField type="date" onChange={(e) => fieldChanged(index, e.target.value, "expiration")} defaultValue={secret.expiration} /></TableCell>
                    <TableCell><TextField type="text" onChange={(e) => fieldChanged(index, e.target.value, "type")} defaultValue={secret.type} /></TableCell>
                    <TableCell><TextField type="date" onChange={(e) => fieldChanged(index, e.target.value, "created")} defaultValue={secret.created} /></TableCell>
                    <TableCell><Button className={classes.okButton} variant="contained" color="primary" onClick={() => RemoveSecret(index)}>Delete</Button></TableCell>
                </TableRow>
    }
    
    const AddSecret = () => {
        let obj = [...secrets];
        obj.push({description: "", value: "", expiration: "", type: "", created: ""})
        setSecrets(obj);
    }
    
    const RemoveSecret = (index) => {
        var obj = [...secrets]
        obj.splice(index, 1);
        setSecrets(obj);
    }

    return <Dialog fullWidth maxWidth="md" onClose={() => props.setDialogState(false)} aria-labelledby="customized-dialog-title" open={props.isOpen}>
                <DialogContent dividers>
                <Button className={classes.closeButton} onClick={() => props.setDialogState(false)}><CloseIcon></CloseIcon></Button>

                    <div className={classes.dialog}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Description</TableCell>
                                    <TableCell>Value</TableCell>
                                    <TableCell>Expiration</TableCell>
                                    <TableCell>Type</TableCell>
                                    <TableCell>Created(required)</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {mapSecrets()}
                            </TableBody>
                        </Table>
                        
                        <div className={classes.dialogFooter}>
                            <Button variant="contained" onClick={() => AddSecret()} className={classes.addSecretButton} color="primary">
                                Add secret
                            </Button>
                            <Button autoFocus className={classes.cancelButton} variant="outlined" onClick={() => props.setDialogState(false)} color="primary">
                                Cancel
                            </Button>
                            <Button className={classes.okButton} variant="contained" color="primary" onClick={() => props.setSecrets(secrets)}>
                                OK
                            </Button>
                        </div>
                       
                    </div>
                </DialogContent>
            </Dialog>
}

const useStyles = makeStyles({

      dialog: {
          //width: "600px",
          //padding: "60px",
          //height: "275px",
          justifyContent: "center",
          textAlign: "center"
      },
      dialogFooter:{
          marginTop: '15px',
        display: 'flex',
        justifyContent: 'center'

      },
      closeButton: {
        float: 'right',
      },
      cancelButton: {
      },
      addSecretButton: {
        marginRight: '10px',
      },
      okButton: {
        marginLeft: '10px',
          backgroundColor: "#5CC958 !important"
      },

      field: {
        display: "block !important"
      }
});